import { ConversationPurposeEntity } from "@/types";
import { ConversationPlatform } from "@/types/conversation";

export interface MeetingType {
  value: ConversationPurposeEntity;
  label: string;
  tooltip: string;
}

export const MEETING_TYPES: MeetingType[] = [
  {
    value: ConversationPurposeEntity.GeneralClientMeeting,
    label: "General client meeting",
    tooltip:
      "For general client meetings including reviews and check-ins for ongoing relationships.",
  },
  {
    value: ConversationPurposeEntity.IntroMeeting,
    label: "Intro & discovery client meeting",
    tooltip:
      "For client meetings focusing on data collection at the start of the relationship.",
  },
  {
    value: ConversationPurposeEntity.SelfDictationMeeting,
    label: "Self dictation meeting",
    tooltip: "For dictating client information, updates, and tasks.",
  },
  {
    value: ConversationPurposeEntity.AllPurposeMeeting,
    label: "All purpose meeting",
    tooltip: "For general notetaking, such as internal team meetings",
  },
];

/**
 * Get meeting type label by value
 * @param purpose - ConversationPurposeEntity value
 * @returns Meeting type label or undefined if not found
 */
export const getMeetingTypeLabel = (
  purpose?: ConversationPurposeEntity,
): string | undefined => {
  return MEETING_TYPES.find((type) => type.value === purpose)?.label;
};

const PLATFORM_LABELS: Record<ConversationPlatform, string> = {
  ZOOM: "Zoom",
  MEET: "Google Meet",
  TEAMS: "Microsoft Teams",
  PHONE: "Phone call",
  INPERSON: "In person",
  MOBILE: "In person",
  WEB: "In person",
  UPLOAD: "File upload",
};

export const getPlatformLabel = (
  platform?: ConversationPlatform | null,
): string | undefined => {
  if (!platform) return undefined;
  return PLATFORM_LABELS[platform];
};
